module.exports = __webpack_public_path__ + "img/logo.18eef7f2.png";